<p>データ削除</p>
<div class="data_count">
    データ件数: {{ block._data_count ?? '-' }}
</div>
